import React from 'react';
import { useQuery } from '@apollo/client';

import DataState from 'app/src/components/DataState';
import Modal from 'app/src/elements/Modal';

import EditExpense from './edit';

import { TXN } from '../Txns/queries';

const EditModal = ({ id, setShowModal, refetch }) => {
  const { data } = useQuery(TXN, { variables: { id } });

  if (!data) { return <DataState.Loading />; }

  return (
    <Modal
      showModal
      setShowModal={setShowModal}
      modalType="Edit Expense"
    >
      <EditExpense
        txn={data.txn}
        setShowModal={setShowModal}
        refetch={refetch}
      />
    </Modal>
  );
};

export default EditModal;
